import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import PageDetail from './pages/PageDetail';
import CategoryPage from './pages/CategoryPage';
import NewsList from './pages/NewsList';
import NewsDetail from './pages/NewsDetail';
import GalleriesPage from './pages/GalleriesPage';
import StaffPage from './pages/StaffPage';
import ContactPage from './pages/ContactPage';
import SignupPage from './pages/SignupPage';
import VisitPage from './pages/VisitPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            
            {/* Direct Feature Pages */}
            <Route path="/skriv-dit-barn-op" element={<SignupPage />} />
            <Route path="/besoeg-skolen" element={<VisitPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/medarbejdere" element={<StaffPage />} />
            <Route path="/gallerier" element={<GalleriesPage />} />
            <Route path="/nyheder" element={<NewsList />} />
            <Route path="/nyheder/:slug" element={<NewsDetail />} />
            
            {/* Dynamic CMS subpages */}
            <Route path="/side/:slug" element={<PageDetail />} />
            
            {/* Section Hubs */}
            <Route path="/:categorySlug" element={<CategoryPage />} />
            
            {/* Errors */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}
